import React from 'react';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';
import { Target, Users, Zap, Quote, MapPin, ShieldCheck, Award, CreditCard } from 'lucide-react';
export function AboutPage() {
  const reviews = [{
    text: 'Brilliant same-day response.',
    author: 'J. Turner'
  }, {
    text: 'Clear pricing and tidy work.',
    author: 'A. Patel'
  }, {
    text: 'Set our system up in minutes.',
    author: 'S. Bennett'
  }];
  return <Layout data-id="element-249">
      <div className="bg-gradient-to-br from-slate-50 to-teal-50 py-16" data-id="element-250">
        <div className="container mx-auto px-4 text-center" data-id="element-251">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-252">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-253">
              About HomeLinkPro
            </h1>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-254">
              Helping UK businesses work smarter, not harder.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Mission Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-255">
        <div className="max-w-4xl mx-auto" data-id="element-256">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-257">
            <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-258">
              Our Mission
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-259">
              HomeLinkPro's mission is to help businesses manage customer
              information, tasks, communication and performance in one organised
              system.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-260">
              Our goal is simple: improving clarity, speed and teamwork across
              your daily operations.
            </p>
          </motion.div>

          {/* Values Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-261">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="text-center p-8 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-262">
              <div className="inline-flex p-4 bg-teal-50 text-teal-600 rounded-full mb-4" data-id="element-263">
                <Target size={32} data-id="element-264" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-265">Clarity</h3>
              <p className="text-slate-600" data-id="element-266">
                Clear information at your fingertips, helping you make confident
                decisions quickly.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-center p-8 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-267">
              <div className="inline-flex p-4 bg-orange-50 text-orange-600 rounded-full mb-4" data-id="element-268">
                <Zap size={32} data-id="element-269" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-270">Speed</h3>
              <p className="text-slate-600" data-id="element-271">
                Streamlined workflows that save time and eliminate unnecessary
                steps.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-center p-8 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-272">
              <div className="inline-flex p-4 bg-teal-50 text-teal-600 rounded-full mb-4" data-id="element-273">
                <Users size={32} data-id="element-274" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-275">
                Teamwork
              </h3>
              <p className="text-slate-600" data-id="element-276">
                Seamless collaboration tools that keep everyone aligned and
                productive.
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Reviews Section */}
      <div className="bg-slate-50 py-20" data-id="element-277">
        <div className="container mx-auto px-4" data-id="element-278">
          <div className="text-center mb-12" data-id="element-279">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-280">
              What Our Clients Say
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-281">
              Real feedback from UK businesses using HomeLinkPro
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-282">
            {reviews.map((review, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-8 rounded-xl border border-slate-100 shadow-sm" data-id="element-283">
                <Quote className="w-10 h-10 text-teal-600 mb-4 opacity-50" data-id="element-284" />
                <p className="text-lg text-slate-700 mb-6 leading-relaxed" data-id="element-285">
                  {review.text}
                </p>
                <p className="font-semibold text-slate-900" data-id="element-286">
                  — {review.author}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="container mx-auto px-4 py-20" data-id="element-287">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-288">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center text-center p-6 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-289">
            <MapPin className="w-8 h-8 text-teal-600 mb-3" data-id="element-290" />
            <span className="font-semibold text-slate-900" data-id="element-291">UK-Based</span>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col items-center text-center p-6 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-292">
            <ShieldCheck className="w-8 h-8 text-teal-600 mb-3" data-id="element-293" />
            <span className="font-semibold text-slate-900" data-id="element-294">Secure Access</span>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col items-center text-center p-6 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-295">
            <Award className="w-8 h-8 text-teal-600 mb-3" data-id="element-296" />
            <span className="font-semibold text-slate-900" data-id="element-297">
              Reliable Service
            </span>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex flex-col items-center text-center p-6 bg-white rounded-xl border border-slate-100 shadow-sm" data-id="element-298">
            <CreditCard className="w-8 h-8 text-teal-600 mb-3" data-id="element-299" />
            <span className="font-semibold text-slate-900" data-id="element-300">Clear Pricing</span>
          </motion.div>
        </div>
      </div>
    </Layout>;
}